module.exports = __webpack_public_path__ + "static/media/ico_down.0e378008.svg";